// extracted by mini-css-extract-plugin
module.exports = {"mytextzone":"style_mytextzone__HUORs","mytext":"style_mytext__1yVPv","current":"style_current__K0pts","mytitle":"style_mytitle__18GNf","mysubtitle":"style_mysubtitle__35RYH"};